import type { UseFormSetValue } from "react-hook-form";
import type {
  PartABPlanCoverageType,
  PartCDPlanCoverageType,
  PlanCoveragesType,
} from "types/DataTypes";

type CoverageFormValues = {
  [key: `${number}_part_${string}_${string}`]: string | number | null;
};

// transform coverage data into form values and set them
export const setCoverageFormValues = (
  planCoverages: PlanCoveragesType,
  setValue: UseFormSetValue<CoverageFormValues>,
) => {
  // set Part A/B coverage form values
  planCoverages.part_a_b_coverages?.forEach(
    (coverage: PartABPlanCoverageType) => {
      const prefix = coverage.type === "A" ? "part_a" : "part_b";

      setValue(
        `${coverage.id}_${prefix}_effective_date`,
        coverage.effective_date,
      );
      setValue(
        `${coverage.id}_${prefix}_termination_date`,
        coverage.termination_date,
      );
    },
  );

  // set Part C/D coverage form values
  planCoverages.part_c_d_coverages?.forEach(
    (coverage: PartCDPlanCoverageType) => {
      const prefix = coverage.type === "C" ? "part_c" : "part_d";
      [
        "pbp_number",
        "contract_number",
        "effective_date",
        "termination_date",
        "contract_name",
        "address1",
        "address2",
        "state",
        "zip",
        "cost_projection",
        "lien",
      ].forEach((field) => {
        setValue(`${coverage.id}_${prefix}_${field}`, coverage[field]);
      });
    },
  );
};
